module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/icons/llm-ea5b67d045946ef9fdd229f4704d9fb1.svg";